import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import { ConsultaSeguimentoPergunta15Model } from './model-consultaSeguimentoPergunta15'

export const convertConsultaSeguimentoPergunta15ToInput = (
  value: ConsultaSeguimentoPergunta15Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_15_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_15_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_15_02,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_15_TENTA_IMITAR?.POE_LINGUA_PRA_FORA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_15_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_15_TENTA_IMITAR?.FAZ_SOM_ENGRACADO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_15_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_15_TENTA_IMITAR?.DA_TCHAU),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_15_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_15_TENTA_IMITAR?.BATE_PALMAS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_15_06,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_15_TENTA_IMITAR?.COLOCA_DEDOS_NOS_LABIOS),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_15_07,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_15_TENTA_IMITAR?.MANDA_BEIJO),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
